import Vue from 'vue'
import Index from './index.vue'
import router from '@/router/router'
import apdetail from '../FApDetail/index.vue'
const EquipDetailConstructor = Vue.extend(Index)
const ApDetailConstructor = Vue.extend(apdetail)


var constructList = []
let init = (options) => {
  let instance = null;
  if(options.type == 'ap'){
    apdetail.install = (data => {
      instance = new ApDetailConstructor().$mount();
      document.body.appendChild(instance.$el);
    })();
  }else if (options.type == 'equip') {
    Index.install = (data => {
      instance = new EquipDetailConstructor().$mount();
      document.body.appendChild(instance.$el);
    })();
  }
  instance.id = options.id;
  constructList.push(instance) 
  if(constructList.length > 5) {
    constructList.splice(0,1)
  }
};

let detail = opts => {
  if (constructList.length == 0) {
    init(opts);
  }else{
   let index = constructList.findIndex(item => {
      return item.id == opts.id   
    })
    if(index > -1 ) {
      const temp = constructList.splice(index,1)
      constructList.push(temp[0])
      constructList[constructList.length - 1].closeDialog();
    }else {
      init(opts);
    }
  }
  Vue.nextTick(() => {
    constructList[constructList.length - 1].open(opts.id);
  });
};

router.afterEach((to, from) => {
  if(constructList.length) {
    // instance.closeDialog();
    constructList.forEach((item) => {
      item.closeDialog();
    })
    constructList = [];
  }
})

export default {
  install: Vue => {
    Vue.prototype.$detail = detail
  }
}

// let ins = [];

// // let instance = null;
// let init = () => {
//   Index.install = (data => {
//     let instance = new Constructor({
//       data
//     }).$mount();
//     document.body.appendChild(instance.$el);
//     ins.push(instance);
//     if (ins.length > 2) {
//       ins.splice(0, 1);
//     }
//   })();
// };
// let detail = equipid => {
//   let index = ins.findIndex(v => v.$el.id == equipid);
//   if (index <= -1) {
//     init();
//   }
//   Vue.nextTick(() => {
//     ins[index > -1 ? index : ins.length - 1].open(equipid);
//   });
// };

// router.afterEach((to, from) => {
//   if (ins.length) {
//     ins.forEach(v => {
//       v.closeDialog();
//     });
//   }
// });

// export default {
//   install: Vue => {
//     Vue.prototype.$detail = detail;
//   }
// };
